import { Flex, FlexProps } from '@chakra-ui/react';

export const FlexRow = Flex;

export const FlexCol = (props: FlexProps) => (
    <Flex direction="column" {...props} />
);
